import React, {Component} from "react";
import {observer, inject} from "mobx-react";
import {Input, Form} from "antd";
import {PICGO_IMAGE_HOSTING} from "../../utils/constant";

const formItemLayout = {
  labelCol: {
    xs: {span: 6},
  },
  wrapperCol: {
    xs: {span: 16},
  },
};

@inject("imageHosting")
@observer
class PicGo extends Component {
  constructor(props) {
    super(props);
    // 从localstorage里面读取
    const imageHosting = JSON.parse(localStorage.getItem(PICGO_IMAGE_HOSTING));
    this.state = {
      imageHosting,
    };
  }

  serverChange = (e) => {
    const {imageHosting} = this.state;
    imageHosting.server = e.target.value;
    this.setState({imageHosting});
    localStorage.setItem(PICGO_IMAGE_HOSTING, JSON.stringify(imageHosting));
  };

  render() {
    const {server} = this.state.imageHosting;
    return (
      <Form {...formItemLayout}>
        <Form.Item label="Server 地址" style={style.formItem}>
          <Input value={server} onChange={this.serverChange} placeholder="例如：http://127.0.0.1:36677" />
        </Form.Item>
        <Form.Item label="提示" style={style.formItem}>
          <span>需先在 PicGo 中开启 Server 服务（默认端口 36677），</span>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://picgo.github.io/PicGo-Doc/zh/guide/"
          >
            PicGo 配置文档
          </a>
        </Form.Item>
      </Form>
    );
  }
}

const style = {
  formItem: {
    marginBottom: "10px",
  },
};

export default PicGo;
